import digitalData from 'digital-data';
import {
  makeEverythingLowerCase,
  setAnalytics
} from '../../../thd-analytics-utils';

export function landingPage() {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('landing-page.page-load', ({ output = {} }) => {
    const {
      title,
    } = output;

    let cleanTitle = title;
    if (cleanTitle !== undefined) {
      cleanTitle = cleanTitle.replace(' - The Home Depot', '');
    }

    digitalData.page = {
      pageInfo: {
        abTest: 'landing-page:version:gen2',
        pageLoadEvent: 'content',
        pageName: cleanTitle,
        pageTemplate: 'default',
        pageType: 'category',
      },
      category: {
        primaryCategory: cleanTitle,
        subCategory1: cleanTitle,
        subCategory2: cleanTitle,
      }
    };

    digitalData.page.pageInfo = makeEverythingLowerCase(digitalData?.page?.pageInfo);
    digitalData.page.category = makeEverythingLowerCase(digitalData?.page?.category);

    setAnalytics(digitalData);
  });

}